enum WorkOrderStatuses {
  Canceled = "Canceled",
  Created = "Created",
  Scheduled = "Scheduled",
  Assigned = "Assigned",
  Accepted = "Accepted",
  InProcess = "InProcess",
  WorkDone = "WorkDone",
  Completed = "Completed",
}

enum PayrollTypes {
  Office = "Shop Time",
  Labor = "Labor Time",
  LaborOvertime = "Labor Overtime",
  Travel = "Travel Time",
  Shop = "Shop Labor",
}

enum SubWorkOrderStatus {
  Canceled = "Canceled",
  Scheduled = "Scheduled",
  Assigned = "Assigned",
  Accepted = "Accepted",
  CustomerContacted = "CustomerContacted",
  InProcess = "InProcess",
  WorkDone = "WorkDone",
}

enum WorkOrderTechStatus {
  Declined = "Declined",
  Assigned = "Assigned",
  Accepted = "Accepted",
  CustomerContacted = "CustomerContacted",
  InRoute = "InRoute",
  OnSite = "OnSite",
  WorkDone = "WorkDone",
}

export { WorkOrderStatuses, SubWorkOrderStatus, WorkOrderTechStatus, PayrollTypes };
